<template>
  <Transition name="fade" appear>
    <div class="dialog" v-if="show" @click="onOverlayClick" @keydown.esc="onEscape">
      <div class="dialog-content" ref="contentRef" tabindex="-1">
        <div class="close-mark"><font-awesome-icon icon="fa-solid fa-xmark" class="icon" @click="hideDialog" /></div>
        <slot></slot>
      </div>

    </div>
  </Transition>
</template>


<script>
import { nextTick, ref, watch, onBeforeUnmount } from 'vue'

export default{
  name:'modal-dialog',
  props:['show'],
  emits: ['update:show'],
  setup(props,{emit}){
    const contentRef = ref(null)

    const hideDialog = ()=>{
      emit('update:show',false)
    }

    const onOverlayClick = (e) => {
      if (e.target && e.target.classList && e.target.classList.contains('dialog')) {
        hideDialog()
      }
    }

    const onEscape = () => {
      hideDialog()
    }

    const onKey = (e) => {
      if (e && e.key === 'Escape') {
        hideDialog()
      }
    }

    watch(
      () => props.show,
      async (visible) => {
        if (visible) {
          document.addEventListener('keydown', onKey)
          await nextTick()
          if (contentRef.value && typeof contentRef.value.focus === 'function') {
            contentRef.value.focus()
          }
        } else {
          document.removeEventListener('keydown', onKey)
        }
      },
      { immediate: true },
    )

    onBeforeUnmount(() => {
      document.removeEventListener('keydown', onKey)
    })

    return { hideDialog, onOverlayClick, onEscape, contentRef }
  }

}

</script>


<style>
.dialog{
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1000;
  display: flex;
  transition: 0.3s ease-out;
}

.dialog-content{
  margin: auto;
  background: white;
  border-radius: 5px;
  min-width: 50px;
  min-height: 50px;
  padding: 12px 14px 14px;
  outline: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.close-mark{
  display: flex;
  justify-content: flex-end;
}

.icon:hover{
  cursor: pointer;

}

</style>
